import ContactTitle from "./components/contactTitle";
import Location from "./components/location";
import Address from "./components/address";
import ContactQr from "./components/contactQr";
import ContactAddress from "./components/contactAddress";
import Subscription from "./components/subscription";
import MailingLists from "./components/mailingLists";
import Chat from "./components/chat";
const ContactUs = () => {
  return (
    <div>
      <Location />
      <ContactTitle />
      <Address />
      <ContactQr />
      {/* 
      <Subscription />
      <Chat />
      <MailingLists />
      <ContactAddress /> */}
    </div>
  );
};
export default ContactUs;
